import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Observable, of, forkJoin, Subject, Subscription, empty, EMPTY } from 'rxjs';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../services/config.service';

import {
  DnvSearchState, SearchItem, initialSearchItem
  , DnvMapState, DnvMapAction, CenterMap, SetZoom, DnvMapInfo, SetMarkers, DnvMarker, DnvLatLng, SetSearchItemsUrl, LayerState
} from 'dnv-lib';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map, takeUntil, filter, delay } from 'rxjs/operators';

import { LocationService } from 'src/app/services';
import { Store } from '@ngrx/store';
import {
  SearchCoordinates, getDnvSearchState
  , SearchFromCoordinates, GetProblems, getProblems, initialProblem
  , SetNoMapLocation, DelayedAction, SearchCoordinatesPayload, getSearchCoordinate, UpdateProblem,
  getMenus, MenuItem, ProblemSource, ProblemStatus, GetMenuOption,
  SetSearchCoordinates, getPropertyOwners, AddProblemContacts,
  DeletePreviousPropertyOwnerContacts, LookupOwnerReset, ProblemMenuConfig, getNewCaseMenu, GetNewCaseMenu, ApplicationState, getApplicationState, IsNation, getMapState, getLayerState, ProblemReceived
} from 'src/app/state-management';
import { ActivatedRoute, Router } from '@angular/router';
import { Problem, NewProblem, ContactDB, ProblemContact } from 'src/app/models/problem';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-problem-location',
    templateUrl: './problem-location.component.html',
    styleUrls: ['./problem-location.component.scss'],
    standalone: false
})
export class ProblemLocationComponent implements OnInit {
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSearchClick = new EventEmitter<SearchItem>();

  fg: UntypedFormGroup;
  routeSubscription: Subscription = new Subscription();
  problemNo: string;
  problemDetail: Problem = initialProblem;
  application$: Observable<ApplicationState>;
  problems$: Observable<Problem[]>;
  menuOption$: Observable<MenuItem>;
  dnvSearchState$: Observable<DnvSearchState>;
  layerState$: Observable<LayerState>;
  locationCoordinate$: Observable<SearchCoordinatesPayload | null>;
  mapState$: Observable<DnvMapState>;
  propertyOwners$: Observable<ContactDB[]>;
  newCaseMenu$: Observable<ProblemMenuConfig[]>;
  propertyOwners: ContactDB[];
  dnvSearchState: DnvSearchState;
  markers: DnvMarker[];
  location: SearchCoordinatesPayload | null;
  problemLatLng: DnvLatLng;
  problemSourceList: ProblemSource[];
  problemStatusList: ProblemStatus[];
  problemReceivedList: ProblemReceived[];
  mapIsDirty = false;
  problemMenuConfig: ProblemMenuConfig[];
  configMenu: ProblemMenuConfig;
  isNation = '';

  private ngUnsubscribe: Subject<void> = new Subject();
  private readonly defaultIcon = 'far fa-question-circle';
  private selected: SearchItem = initialSearchItem;
  public search: (text$: Observable<string>) => Observable<SearchItem[]>;

  constructor(private store: Store<{}>,
    private locationService: LocationService,
    private route: ActivatedRoute,
    private router: Router,
    private configService: ConfigService) {
    this.problems$ = this.store.select(getProblems);
    this.menuOption$ = this.store.select(getMenus);
    this.mapState$ = this.store.select(getMapState);
    this.dnvSearchState$ = this.store.select(getDnvSearchState);
    this.layerState$ = this.store.select(getLayerState);
    this.locationCoordinate$ = this.store.select(getSearchCoordinate);
    this.propertyOwners$ = this.store.select(getPropertyOwners);
    this.newCaseMenu$ = this.store.select(getNewCaseMenu);
    this.application$ = this.store.select(getApplicationState);

    this.propertyOwners = [];

    this.fg = new UntypedFormGroup({
      addressSearch: new UntypedFormControl('', [Validators.required]),
      addressSearchOrigin: new UntypedFormControl(''),
      mapLocation: new UntypedFormControl('', [Validators.required]),
    });
  }

  onSelectItem(event: NgbTypeaheadSelectItemEvent) {
    this.configMenu = this.problemMenuConfig.filter(m => m.group_RefId === this.problemDetail.group_RefId
      && m.problemType_RefId === this.problemDetail.problemType_RefId)[0];

    this.fg.get('addressSearchOrigin')
      .setValue(event.item.name);
    this.selected = event.item as SearchItem;
    this.store.dispatch(new SearchCoordinates({ ...this.selected, problemMenu: this.configMenu }));
  }

  ngOnInit() {
    this.store.dispatch(new SetSearchCoordinates(null));
    this.store.dispatch(new LookupOwnerReset());
    // this.store.dispatch(new SetSearchItemsUrl(`${environment.searchApiEndpointUrl}api/`));
    this.store.dispatch(new GetNewCaseMenu());
    this.store.dispatch(new IsNation(''));

    this.application$
      .pipe(
        takeUntil(this.ngUnsubscribe),
      ).subscribe(a => {
        this.isNation = a.isNation;
      });

    this.routeSubscription = this.route.queryParams
      .pipe(filter(params => params.ProblemNo))
      .subscribe(params => {
        this.problemNo = params.ProblemNo;
        this.store.dispatch(new GetProblems({ problemNo: this.problemNo }));
        this.store.dispatch(new GetMenuOption());
      });

    this.dnvSearchState$
      .pipe(
        takeUntil(this.ngUnsubscribe),
      ).subscribe(s => {
        this.dnvSearchState = s;
      });

    this.mapState$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe(mapState => {
        this.markers = mapState.markers;

        if (mapState && mapState.markers.length > 0 && mapState.markers[0].icon.className === 'myDivIcon') {
          this.fg.get('mapLocation').setValue(true);
          // this.mapLocationRequired = false;
        } else {
          this.fg.get('mapLocation').setValue(null);
          // this.mapLocationRequired = true;
        }
      });

    this.menuOption$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe(menu => {
        this.problemSourceList = menu.problemSourceList;
        this.problemStatusList = menu.problemStatusList;
        this.problemReceivedList = menu.problemReceivedFromList;

      });

    this.propertyOwners$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe((po: ContactDB[]) => {
        this.propertyOwners = po;
      });


    this.search = (text$: Observable<string>): Observable<SearchItem[]> => {
      return text$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
          // const currentSearchUrl = this.dnvSearchState.searchItemsUrl + 'searchitems/' + name;
          if (name.length > 0) {
            return forkJoin({
              searchItems:
                this.locationService.getSearchItems('api/gis/searchapp/' + name)
                  .pipe(
                    catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }),
                  ),
              intersections:
                this.locationService.getSearchItems('api/gis/searchitems/' + name)
                  .pipe(
                    catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }),
                  ),
            });
          } else {
            return EMPTY;
          }
        }),
        map(itemsMap => {
          return [...itemsMap.searchItems, ...itemsMap.intersections];
        })
      );
    };

    this.locationCoordinate$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe((location: SearchCoordinatesPayload | null) => {
        if (location) {
          this.location = location;
          const searchBar = this.fg.get('addressSearch').value;

          if (!location.name.startsWith('Out of Boundary')) {
            if (location.updatedBy === 'Click') {
              this.fg.get('addressSearch')
                .setValue({ name: location.name, id: 0, type: '', updatedBy: location.updatedBy });
            }

            this.fg.get('addressSearchOrigin')
              .setValue(location.name);
          }

          // let marker: DnvMarker;

          const latLng: DnvLatLng = {
            lat: location.success.lat
            , lng: location.success.lng
          };

          this.problemLatLng = latLng;

          this.store.dispatch(new DelayedAction([
            // new SetMarkers([marker]),
            new DelayedAction([
              new CenterMap({ lat: location.success.lat, lng: location.success.lng }),
              new SetZoom(Number(5)),
            ])
          ]));

          this.mapIsDirty = true;
        }
      });

    this.problems$
      .pipe(
        delay(200),
        takeUntil(this.ngUnsubscribe),
      ).subscribe(p => {
        this.problemDetail = p[0];
        if (this.problemDetail) {
          this.fg.get('addressSearch').setValue({
            name: this.problemDetail.problemLocation
            , id: 0, type: '', updatedBy: 'KL'
          });
          this.fg.get('addressSearchOrigin').setValue(this.problemDetail.problemLocation);

          if (this.problemDetail.latLng.lat === 0 && this.problemDetail.latLng.lng === 0) {
            this.store.dispatch(new SetNoMapLocation(true));
            this.problemLatLng = { lat: 0, lng: 0 };
          } else {
            this.problemLatLng = { lat: this.problemDetail.latLng.lat, lng: this.problemDetail.latLng.lng };

            const marker: DnvMarker = {
              url: new Date().toISOString(),
              centerPoint: this.problemLatLng,
              popup: '',
              popupOptions: { maxWidth: 400 },
              tooltip: this.problemDetail.problemLocation,
              tooltipOptions: {
                permanent: false,
                direction: 'right',
                offset: [14, -20],
                className: 'map-tooltip'
              },
              clickEvent: true,
              id: this.problemDetail.problemLocation,
              isActive: false,
              activeIcon: {
                iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
                className: 'myDivIconSelected',
                iconSize: [35, 60],
              },
              icon: {
                iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
                className: 'myDivIcon',
                iconSize: [35, 60],
              }
            };

            this.store.dispatch(new SetNoMapLocation(false));
            this.store.dispatch(new SetMarkers([marker]));
            this.store.dispatch(new DelayedAction([
              new CenterMap(this.problemDetail.latLng),
              new SetZoom(Number(5))
            ]));
          }

        }
      });

    this.newCaseMenu$
      .pipe(
        takeUntil(this.ngUnsubscribe),
      ).subscribe(m => {
        this.problemMenuConfig = m;
      });
  }


  // Format the autosuggested item into a string for the input control
  formatter = (x: { name: string }) => x.name;

  getClass(type: number): string {
    let result = this.defaultIcon;
    if (this.dnvSearchState.icons) {
      const icon = this.dnvSearchState.icons.find(x => x.id === type);
      if (icon) {
        result = icon.fontAwesome;
      }
    }
    return result;
  }

  onBlur() {
    const locString = this.fg.get('addressSearch').value;
    if (typeof locString === 'string' && '' !== locString) {
      this.fg.get('addressSearch').setValue({ name: locString, id: 0, type: '' });
      // this.fg.get('addressSearchOrigin').setValue(locString);
    }
  }

  saveLocation() {
    const probStatus: ProblemStatus = this.problemStatusList.find(s => s.problemStatus_Name === this.problemDetail.problemStatus.trim());
    const probSource: ProblemSource = this.problemSourceList.find(s => s.problemSource_Name === this.problemDetail.problemSource.trim());
    const probReceived: ProblemReceived = this.problemReceivedList.find(s => s.problemReceivedFrom_Name === this.problemDetail.problemReceivedFrom.trim());

    const modifiedProblem: NewProblem = {
      problem_Id: this.problemDetail.problemId,
      caseNo: this.problemDetail.problemNo,
      group_RefId: this.problemDetail.group_RefId,
      problemType_RefId: this.problemDetail.problemType_RefId,
      description: this.problemDetail.problemDescription,
      problemStatus_RefId: probStatus.problemStatus_Id,
      problemSource_RefId: probSource.problemSource_Id,
      location_Description: this.fg.get('addressSearch').value.name,
      location_Description_Origin: this.fg.get('addressSearchOrigin').value,
      location_Longitude: this.problemLatLng.lng,
      location_Latitude: this.problemLatLng.lat,
      problemPriority_RefId: this.problemDetail.problemPriority_RefId,
      problemReceivedFrom_RefId: probReceived.problemReceivedFrom_Id
    } as NewProblem;

    this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: modifiedProblem }));

    this.store.dispatch(new DeletePreviousPropertyOwnerContacts());

    if (this.propertyOwners.length > 0) {
      const owners: ProblemContact[] = [];
      this.propertyOwners.slice(0, 3).forEach(o => {
        const propertyOwner: ProblemContact = {
          firstName: o.firstName,
          lastName: o.lastName,
          email: o.email,
          street: o.street,
          notes: 'Owner of ' + this.fg.get('addressSearch').value.name,
          phone: [],
          contactType: 'Property Owner',
          companyName: ''
        };
        owners.push(propertyOwner);
      });

      this.store.dispatch(new AddProblemContacts({ problem_Id: this.problemDetail.problemId, contacts: owners }));
    }

    this.router.navigateByUrl('/problemdetails?ProblemNo=' + this.problemDetail.problemNo);
  }

  cancel() {
    this.router.navigateByUrl('/problemdetails?ProblemNo=' + this.problemDetail.problemNo);
  }

  isEnabled() {
    if (!this.fg.valid) {
      return true;
    }

    if (this.fg.dirty) {
      return false;
    }

    if (this.mapIsDirty) {
      return false;
    }

    return true;
  }

  onMapUpdate(action: any) {
    if (action.type) {
      this.store.dispatch(action);
    } else if (action.length == 1) {
      this.store.dispatch(action[0]);
    }
    else {
      action.forEach((act: DnvMapAction) => {
        this.store.dispatch(act);
      })
    }

  }

  onMoveChange(state: DnvMapState) {
    this.store.dispatch(new CenterMap({ lat: state.centerPoint.lat, lng: state.centerPoint.lng }));
  }

  onZoomChange(state: DnvMapState) {
    this.store.dispatch(new SetZoom(state.zoomLevel));
  }

  onMapClick(info: DnvMapInfo) {
    // this.store.dispatch(new SearchCoordinatesSuccess(null));
    this.configMenu = this.problemMenuConfig.filter(m => m.group_RefId === this.problemDetail.group_RefId && m.problemType_RefId === this.problemDetail.problemType_RefId)[0];
    this.store.dispatch(new SetMarkers([]));
    this.store.dispatch(new SearchFromCoordinates({
      problemMenu: this.configMenu,
      dnvMapInfo: info,
      zoneLookupOnly: false
    }));
  }
}
